import styles from "./BoostCard.module.scss";
import currencyIcon from '../../icons/currency.png';
import arrowIcon from "../../icons/arrow.png";
import image from "./icons/boost1.jpg";
import { useDispatch, useSelector } from "../../hooks";
import { buyBoost } from "../../redux/boosts/buy-boost.handler";
import { ILibBoost } from "../../redux/boosts/get-boosts.handler";
import { FC } from "react";
import { formatNumberWithSpaces } from "../../utils/numbers";
import { trueDrawsForm } from "../../utils/true.word.form";
import { BalanceErrorType, useBalanceError } from "../../hooks/error";
import { setUserExp } from "../../redux/user";
import { BuyButton } from "../Buttons/BuyButton/BuyButton";

interface IBoostCardProps extends ILibBoost {
    userCount: number;
}

export const BoostCard: FC<IBoostCardProps> = ({ id, name, description, count, userCount, cost }) => {
    const dispatch = useDispatch();
    const balance = useSelector(store => store.user.info.balance);
    const balanceError = useBalanceError();

    const onBoostBuyHandler = async () => {
        if (balance < cost) {
            balanceError(cost, BalanceErrorType.Boost);
            return;
        }

        const resultAction = await dispatch(buyBoost(id));
        if (buyBoost.fulfilled.match(resultAction)) {
            const { exp } = resultAction.payload;
            if (exp !== undefined)
                dispatch(setUserExp(exp));
        }
    }

    return (
        <div className={styles.card}>
            <div className={styles.imageContainer}>
                <img
                    src={ image }
                    alt="Boost"
                    className={styles.image}
                />
            </div>

            <div className={styles.progressSection}>
                <div className={styles.progressHeader}>
                
                <span className={styles.progressLabel}>
                    Осталось 
                    <img
                        src={arrowIcon}
                        alt="Arrow Icon"
                        className={styles.arrowIcon}
                    />
                </span>

                <span className={styles.progressValue}>{ userCount }</span>
                
                </div>
                    <div className={styles.progressBar}>
                        <div className={styles.progressFill} style={{ width: "100%" }}></div>
                    </div>
                </div>

                <div className={styles.details}>
                    <div className={styles.confirmations}>
                    
                    <span>{count} { trueDrawsForm(count) }</span>
                    
                    <span className={styles.price}>
                        <img src={currencyIcon} alt="Currency" />
                        { formatNumberWithSpaces(cost) }
                    </span>
                    
                    </div>
                    
                    <div className={styles.textBlock}>
                    
                    <p className={styles.description}>
                        “{name}” – {description}
                    </p>
                </div>
            </div>

            <BuyButton cost={ cost } caption={'Купить'} handler={ onBoostBuyHandler } />

            <div className={ styles.costDescription }>Стоимость увеличивается с каждой покупкой</div>
        </div>
    );
};
